import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyTable from '../../components/tables/BakeasyTable';
import {
  BakeasyChip,
  BakeasyChipFilterCancel,
} from '../../components/common/BakeasyChip';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/styles.css';
import {
  BakeasyButtonAssign,
  BakeasyButtonUnassign,
} from '../../components/buttons/BakeasyButton';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import {
  assignedUnassignedProduct,
  downloadStoreProducts,
  fetchStoreProducts,
  storeProductState,
} from '../../redux_store/slices/storeProductSlice';
import BakeasySwitch from '../../components/common/BakeasySwitch';
import { clearCategoryState } from '../../redux_store/slices/categorySlice';
import { clearSubCategoryState } from '../../redux_store/slices/subCategorySlice';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import { t } from 'i18next';
import * as Button from '../../components/buttons/BakeasyButtons';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { storeProductsTableHeaders } from '../../constants/TableHeaders';
import { FILTERS_ARRAY } from '../../constants/Constants';
import { deleteKeyFromObject, preparePayload } from '../../utils/commonUtils';

export const StoreProducts: FC = (): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const tableRef = React.useRef<any>();
  let myContext = React.useContext(AppContext);

  const [storeList, setStoreList] = useState<any[]>([]);
  const [search, setSearch] = useState<string>('');
  const [count, setCount] = React.useState<number>(0);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [storeEntityId, setstoreEntityId] = useState<string>(
    location?.state?.storeEntityId
  );
  const [tFilter, setTFilter] = React.useState<any>({});

  let { value, rowsPerPage, pageNo, filter } =
    useAppSelector(storeProductState);

  const refreshPageData = async (
    newPage: number,
    search?: string,
    filter?: {} | undefined
  ) => {
    let payload = await preparePayload(
      { limit: rowsPerPage },
      filter,
      search,
      newPage
    );

    if (
      location?.state?.storeEntityId !== '' &&
      location?.state?.storeEntityId !== undefined
    ) {
      payload = { ...payload, storeEntityId: location?.state?.storeEntityId };
    }

    await dispatch(fetchStoreProducts(payload));
  };

  useEffect(() => {
    if (value?.totalCount === -1) {
      refreshPageData(pageNo);
    } else {
      const filteredData: any = value?.data?.map((storeProducts: any) => {
        return {
          productName: storeProducts?.productName,
          onProductNameClick: () => {
            dispatch(clearCategoryState());
            dispatch(clearSubCategoryState());
            navigate('/createProduct', {
              state: { isView: true, isEdit: false, _id: storeProducts?._id },
            });
          },
          price: storeProducts?.price,
          categoryName: storeProducts?.categoryName,
          subCategoryName: storeProducts?.subCategoryName,
          status: (
            <BakeasyChip
              label={
                storeProducts?.status === 'Active'
                  ? 'Active'
                  : storeProducts?.status === 'Inactive'
                    ? 'InActive'
                    : 'Temp. Unavailable'
              }
            />
          ),
          productChecked:
            storeProducts?.productStatus === 'Assigned' ? true : false,
          _id: storeProducts?._id,
          productStatus: (
            <BakeasySwitch
              value={storeProducts?.productStatus === 'Assigned' ? true : false}
              onChange={(event: any) => {
                event.stopPropagation();
                storeProducts?.productStatus === 'Assigned'
                  ? openDeActivateProductConfirmDialog({
                      products: [
                        {
                          id: storeProducts?._id,
                          storeCost: storeProducts?.price,
                        },
                      ],
                      storeEntityId,
                      assignment: 'unassign',
                    })
                  : openReActivateProductConfirmDialog({
                      products: [
                        {
                          id: storeProducts?._id,
                          storeCost: storeProducts?.price,
                        },
                      ],
                      storeEntityId,
                      assignment: 'assign',
                    });
              }}
            />
          ),
        };
      });

      const checkedProducts = filteredData.filter(
        (product: any) => product.productChecked === true
      );
      setSelectedRows(checkedProducts);
      setStoreList(filteredData);
      setCount(value?.totalCount);
    }
  }, [value]);

  function openReActivateProductConfirmDialog(payload: any) {
    myContext.setConfirmDialog({
      type: 'assign',
      open: true,
      title: t('ASSIGN_PRODUCT'),
      message: t('ASSIGN_PRODUCT_MESSAGE'),
      onYesClick: async (event: any, param: string | undefined) => {
        await dispatch(assignedUnassignedProduct(payload));
        await refreshPageData(pageNo - 1);
      },
    });
  }

  function openDeActivateProductConfirmDialog(payload: any) {
    myContext.setConfirmDialog({
      type: 'unassign',
      open: true,
      title: t('UNASSIGN_PRODUCT'),
      message: t('UNASSIGN_PRODUCT_MESSAGE'),
      onYesClick: async (event: any, param: string | undefined) => {
        await dispatch(assignedUnassignedProduct(payload));
        await refreshPageData(pageNo - 1);
      },
    });
  }

  const handleRowCheck = (rows: any, checked: boolean) => {
    if (checked) {
      setSelectedRows([...selectedRows, ...rows]);
    } else {
      const filterRows = selectedRows.filter(
        (tableRow: any) => !rows.some((row: any) => tableRow._id === row._id)
      );
      setSelectedRows([...filterRows]);
    }
    // if (checked) {
    //   setSelectedRows([...selectedRows, row]);
    // } else {
    //   const filterRows = selectedRows.filter((tableRow: any) => tableRow._id !== row._id);
    //   setSelectedRows([...filterRows]);
    // }
  };

  const handleAssignClick = async () => {
    if (selectedRows.length === 0) {
      dispatch(showErrorSnackbar({ message: t('NO_PRODUCTS_ASSIGNMENT') }));
      return;
    }
    const payload = {
      storeEntityId,
      assignment: 'assign',
      products: selectedRows.map((row: any) => ({ id: row._id })),
    };

    await dispatch(assignedUnassignedProduct(payload));
    await refreshPageData(pageNo - 1);
  };

  const handleUnAssignClick = async () => {
    if (selectedRows.length === 0) {
      dispatch(
        showErrorSnackbar({ message: t('NO_PRODUCTS_SELECTED_UNASSIGNMENT') })
      );
      return;
    }
    const payload = {
      storeEntityId,
      assignment: 'unassign',
      products: selectedRows.map((row: any) => ({ id: row._id })),
    };
    await dispatch(assignedUnassignedProduct(payload));
    await refreshPageData(pageNo - 1);
  };

  function openFilterConfirmDialog() {
    myContext.setConfirmDialog({
      type: 'store-product-filter',
      open: true,
      title: 'STORE_PRODUCT_FILTER',
      data: filter,
      onNoClick: (event: any) => {},
      onYesClick: async (event: any, param: any) => {
        setTFilter(param);
        refreshPageData(0, search, param);
      },
    });
  }

  const handleDelete = async (key: any) => {
    // const newFilters = { ...tFilter };
    // delete newFilters[key];
    let newFilters = await deleteKeyFromObject(key, tFilter);
    setTFilter(newFilters);
    refreshPageData(pageNo - 1, search, newFilters);
  };

  function storeProductsUI() {
    return (
      <Grid style={{ padding: 1 }}>
        <Grid item>
          <BakeasyAppBar
            title={t('STORE_PRODUCTS')}
            onBackClick={() => {
              navigate(-1);
            }}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Search
                value={search}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setSearch(event?.target?.value);
                  if (
                    event?.target?.value?.length === 0 ||
                    event?.target?.value?.length > 2
                  ) {
                    refreshPageData(
                      pageNo - 1,
                      event?.target?.value?.length === 0
                        ? undefined
                        : event?.target?.value,
                      filter
                    );
                  }
                }}
                onIconClick={(
                  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
                onEnterClick={(
                  event: React.KeyboardEvent<HTMLInputElement>
                ) => {
                  refreshPageData(pageNo - 1, search, filter);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
              <div className="tableOptions">
                <Button.Print
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      downloadStoreProducts({ ...filter, downloadType: 'pdf' })
                    );
                  }}
                />
                <Button.Export
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      downloadStoreProducts({ ...filter, downloadType: 'csv' })
                    );
                  }}
                />

                <Button.Filter
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    openFilterConfirmDialog();
                  }}
                />

                <BakeasyButtonAssign onClick={handleAssignClick} />
                <BakeasyButtonUnassign onClick={handleUnAssignClick} />
              </div>
            </Grid>
          </Grid>

          <Grid sx={{ mt: 1, mb: -1 }}>
            {Object.entries(filter).map((item: any, index: number) => {
              if (!FILTERS_ARRAY.includes(item[0])) {
                return (
                  <BakeasyChipFilterCancel
                    label={item[0] + ' : ' + item[1]}
                    onDelete={() => {
                      handleDelete(item[0]);
                    }}
                  />
                );
              }
            })}
          </Grid>

          <Grid>
            {storeList.length > 0 ? (
              <BakeasyTable
                ref={tableRef}
                pageNo={pageNo - 1}
                search={search}
                headers={storeProductsTableHeaders}
                tableData={storeList}
                count={count}
                refreshPageData={refreshPageData}
                handleCheckChanged={handleRowCheck}
                filter={filter}
              />
            ) : (
              <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
            )}
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return storeProductsUI();
};
